import { t } from 'i18next';
import { AnimatedLogisticBanner } from 'images';

import { Flex } from '@olist/united';

export const bannerData = [
  {
    badgeLabel: t`operational efficiency`,
    badgeColor: 'primary',
    showBadgeIcon: false,
    borderColor: 'primary',
    file: AnimatedLogisticBanner,
    title: t`have the pickup in your store`,
    subTitle: t`the olist store offers the pickup service* that guarantees security and agility in shipping`,
    listLabel: t`in addition to the pickup, save with:`,
    listItems: [
      {
        text: t`shipping table 19% cheaper than the market`,
      },
      {
        text: `co-participation of up to 50% of the olist in the payment of free shipping`,
      },
    ],
    linkLabel: t`check the cities served`,
  },
  {
    badgeLabel: t`compatible address`,
    badgeColor: 'success',
    showBadgeIcon: true,
    borderColor: 'accent',
    file: AnimatedLogisticBanner,
    title: t`collection available`,
    subTitle: (
      <>
        <Flex mb={4}>
          {t`the olist store offers a collection service that guarantees faster delivery, so that you can buy items conveniently.`}
        </Flex>
        <Flex mb={4}>
          {t`After your first sale, the partner driver goes to your logistics address and collects your orders for shipment to the end customer.`}
        </Flex>
      </>
    ),
  },
  {
    badgeLabel: t`mismatched address`,
    badgeColor: 'error',
    showBadgeIcon: true,
    borderColor: 'alert',
    file: AnimatedLogisticBanner,
    title: t`collection unavailable`,
    subTitle: (
      <>
        <Flex mb={4}>
          {t`Unfortunately your logistical address does not match our collection range. But we may notify you when we have collection available for this address.`}
        </Flex>
      </>
    ),
  },
];
